<header class="topbar">
	<button class="topbar__hamburger" (click)="sidebar.toggle()">
		<i class="pi pi-bars"></i>
	</button>

	@if (crumb()) {
	<span class="topbar__crumb">{{ crumb() }}</span>
	}

	<div class="topbar__spacer"></div>

	<!-- ----- Bouton cotisation -->
	@if (hasCotisation()) {
	<button
		class="topbar__action topbar__action--wide"
		[class.topbar__action--member]="isMember()"
		data-dict-key="devenir_membre"
		(click)="openModule('club-cotisation')">
		<i [class]="isMember() ? 'fa fa-check' : 'fa fa-id-card-clip'"></i>
		<span>{{ Dic.devenir_membre.text }}</span>
	</button>
	}

	<!-- ----- Appels visio -->
	@if (showVideoCall()) {
	<button
		class="topbar__action topbar__action--primary"
		data-dict-key="livekitlobby"
		[pTooltip]="Dic.livekitlobby.text"
		tooltipPosition="bottom"
		[attr.aria-label]="Dic.livekitlobby.text"
		(click)="openModule('myap-livekit-lobby')">
		<i class="fa fa-video-camera"></i>
	</button>
	}

	<!-- ----- Menu utilisateur -->
	<button class="topbar__user" (click)="userMenu.toggle($event)">
		<span class="shell-avatar">{{ userInitials() }}</span>
		<span class="topbar__user-text">
			<span class="topbar__user-name">{{ displayName() }}</span>
			@if (hasCotisation()) {
			<span class="topbar__user-role" [class.topbar__user-role--member]="isMember()">
				@if (isMember()) { {{ Dic.member.text }} } @else { {{ Dic.nomember.text }} }
			</span>
			} @else if (subtitle()) {
			<span class="topbar__user-role">{{ subtitle() }}</span>
			}
		</span>
		<i class="pi pi-angle-down topbar__user-chevron"></i>
	</button>
</header>

<p-popover #userMenu styleClass="topbar-user-popover" appendTo="body">
	<topbar-user-menu (close)="userMenu.hide()" />
</p-popover>
